import { FieldBuilder } from '@zendra/shared';
FieldBuilder.setNamespace('Geographic');
export const OTHERUSEINCONSISTENCYONLYINZENDRA_FIELDS = [
  FieldBuilder.text('propertyName', 'Entity.OtherUseInconsistency.Property').readOnly().build(),
  FieldBuilder.text('name', 'Entity.OtherUseInconsistency.OtherUse').readOnly().build(),
  FieldBuilder.number('area', 'Entity.OtherUseInconsistency.Area').decimal().readOnly().build(),
  FieldBuilder.text('soilUse', 'Entity.OtherUseInconsistency.SoilUse').readOnly().build(),
  FieldBuilder.text('conservationType', 'Entity.OtherUseInconsistency.ConservationType').readOnly().build(),
];
export const OTHERUSEINCONSISTENCYONLYINZENDRA_CONFIG = {
  entityName: 'OtherUseInconsistencyOnlyInZendra',
  localizationKey: 'Geographic::Entity.OtherUseInconsistencyOnlyInZendra',
  fields: OTHERUSEINCONSISTENCYONLYINZENDRA_FIELDS,
  permission: 'PlanningLocation.OtherUses', showInMenu: false,
};
